import { ButtonCTA, SpinnerSmall, TextField } from 'components/ui';
import { useEffect, useRef } from 'react';
import { useUpdatePasswordMutation } from 'store/services/segmentsApi';
import { usePageTitle } from 'utils';

export default function ChangePassword() {
  const formRef = useRef(null);

  const passwordFieldRef = useRef(null);
  const confirmPasswordFieldRef = useRef(null);

  const [updatePassword, { isLoading }] = useUpdatePasswordMutation();

  function validatePassword() {
    if (
      // @ts-ignore
      passwordFieldRef.current.value !== confirmPasswordFieldRef.current.value
    ) {
      // @ts-ignore
      confirmPasswordFieldRef.current.setCustomValidity(
        'Passwords do not match. Try again'
      );
    } else {
      // @ts-ignore
      confirmPasswordFieldRef.current.setCustomValidity('');
    }
  }

  useEffect(() => {
    const inputs = document.querySelectorAll('input');

    inputs.forEach((input) => {
      input.addEventListener(
        'invalid',
        () => {
          input.classList.add(
            'focus:ring-segments-at-risk',
            'focus:border-segments-at-risk'
          );
        },
        false
      );
      input.addEventListener('change', validatePassword);
    });
  }, []);

  /** @param {*} event */
  async function handleOnSubmit(event) {
    event.preventDefault();
    let { old_password, password, confirm_password } = event.target;

    const body = {
      old_password: old_password.value,
      new_password: password.value,
    };
    updatePassword(body).finally(() => {
      old_password.value = '';
      password.value = '';
      confirm_password.value = '';
    });
  }

  usePageTitle('Change password | Segments');
  return (
    <div className="relative">
      <div className="max-w-screen-xl px-5 mx-auto md:pl-segments-72px md:pr-20 py-11">
        <div>
          <p className="font-bold">Settings</p>
          <h1 className="text-2xl font-bold md:text-4xl lg:text-segments-44px md:mt-2">
            Change password
          </h1>
        </div>
        <div className="flex items-center justify-center h-full mt-20">
          <form
            ref={formRef}
            className="w-full max-w-2xl mt-8"
            onSubmit={handleOnSubmit}
          >
            <div className="items-center grid-cols-2 lg:grid">
              <label htmlFor="old_password" className="text-base">
                Current password
              </label>
              <TextField
                // @ts-ignore
                name="old_password"
                type="password"
                minLength={5}
                maxLength={128}
                placeholder="Required"
                required
              />
            </div>
            <div className="items-center grid-cols-2 mt-4 lg:grid lg:mt-0">
              <label htmlFor="new_password" className="text-base">
                New password
              </label>
              <TextField
                ref={passwordFieldRef}
                // @ts-ignore
                name="password"
                type="password"
                minLength={5}
                maxLength={128}
                placeholder="Required"
                required
              />
            </div>
            <div className="items-center grid-cols-2 mt-4 lg:grid lg:mt-0">
              <label htmlFor="confirm_password" className="text-base">
                Confirm new password
              </label>
              <TextField
                ref={confirmPasswordFieldRef}
                // @ts-ignore
                name="confirm_password"
                type="password"
                minLength={5}
                maxLength={128}
                placeholder="Required"
                required
              />
            </div>
            <div className="flex justify-end mt-16">
              <div>
                <ButtonCTA variant="main" type="submit">
                  <div className="w-40">
                    {isLoading ? <SpinnerSmall /> : 'Save changes'}
                  </div>
                </ButtonCTA>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
